import * as persistent from './persistent';

const PORTAL_LOCALE = "pil_locale";
const GDPR_CONSENT = "pil_gdprConsent";
const GDPR_ACCEPTED = "accepted";

export const setLocale = (value) => {
	persistent.setPersistentValue(PORTAL_LOCALE, value);
};

export const getLocale = () => {
	return persistent.getPersistentValue(PORTAL_LOCALE);
};

// Want to set GDPR consent across subdomains, but local storage
// doesn't support, so use cookies.
export const setGDPRConsent = (value) => {
	if (value) {
		// persistent.setPersistentValue(GDPR_CONSENT, GDPR_ACCEPTED);
		persistent.setCookieValue(GDPR_CONSENT, GDPR_ACCEPTED, 365, true);
	}
	else if (getGDPRConsent()) {
		// performance.removePersistentValue(GDPR_CONSENT);
		persistent.removeCookieValue(GDPR_CONSENT);
	}
};

export const getGDPRConsent = () => {
	// return persistent.getPersistentValue(GDPR_CONSENT);
	return persistent.getCookieValue(GDPR_CONSENT);
};

export const getLanguageWithoutRegionCode = () => { 
	const language = (navigator.languages && navigator.languages[0]) ||
		navigator.language ||
		navigator.userLanguage;
	return language.toLowerCase().split(/[_-]+/)[0];
};


// WEBPACK FOOTER //
// ./src/functions/locale.js